import React, { useEffect, useRef } from "react";

import "@esri/calcite-components/components/calcite-link";
import "@esri/calcite-components/components/calcite-loader";

import useBogsGisPortalAuth from "@cores/security/hooks/useBogsGisPortalAuth";
import { WarningNotice } from "@libs/components/common/Notices";
import { AppResource } from "@config/config";

import "./PgAppSsoAuth.css";

export default function PgAppSsoAuth() {
  const {
    loading,
    signedIn,
    portalUser,
    niogemsAuth,
    fetchNiogemsToken
  } = useBogsGisPortalAuth();

  // Prevent duplicate token-exchange requests.
  const hasDispatched = useRef(false);

  useEffect(() => {
    if (
      !loading &&
      signedIn &&
      portalUser?.email &&
      !hasDispatched.current
    ) {
      hasDispatched.current = true;
      fetchNiogemsToken();
    }
  }, [
    loading,
    signedIn,
    portalUser,
    fetchNiogemsToken
  ]);

  const isDisplayMessage =
    niogemsAuth?.action === "display";

  const loadingTitle = !signedIn
    ? "Verifying Portal Identity..."
    : "Securing NIOGEMS Access...";

  return (
    <main className="sso-auth-page">
      <div className="sso-auth-content">
        {isDisplayMessage ? (
          <WarningNotice
            title={`Access State: ${niogemsAuth.status}`}
            message={
              niogemsAuth.message ||
              "An authentication problem was encountered."
            }
            className="sso-auth-notice"
          >
            <div
              slot="link"
              className="sso-auth-actions"
            >
              <p className="sso-auth-actions__message">
                If the sign-in process took too long,
                your session may have timed out.
                Try reloading the page, or return to
                the Portal.
              </p>

              <div className="sso-auth-actions__buttons">
                <calcite-link
                  href={AppResource.ssoauth_url}
                >
                  Back to the Portal
                </calcite-link>

                <calcite-link
                  onClick={() =>
                    window.location.reload()
                  }
                >
                  Reload Page
                </calcite-link>
              </div>
            </div>
          </WarningNotice>
        ) : (
          <section
            className="sso-auth-loading"
            role="status"
            aria-live="polite"
          >
            <calcite-loader
              active
              label={loadingTitle}
              text="Establishing your secure single sign-on session..."
              scale="l"
            />

            <p className="sso-auth-loading__message">
              Please wait while we establish your
              secure single sign-on session.
            </p>
          </section>
        )}
      </div>
    </main>
  );
}